import React, { useEffect } from "react";
import styles from './modal.module.css';
import ModalOverlay from "../modal-overlay/modal-overlay";
import { createPortal } from "react-dom";
import { useDispatch } from "react-redux";
import { DECREMENT_SLIDE, INCREMENT_SLIDE } from "../../services/actions/portal_actions";
import { START_LOADING } from "../../services/actions/loading_actions";


function Modal({ onClose, backing=true, backingWhite=false, children }) {

  const portalDiv = document.getElementById("modal");
  const dispatch = useDispatch();

  const handleClose = () => {
    onClose();
  }

  function closeByEsc(e) {
    if(e.key === "Escape") {
      handleClose();
    } else if (e.key === "ArrowLeft") {
      dispatch({ type: START_LOADING });
      dispatch({ type: DECREMENT_SLIDE });
    } else if (e.key === "ArrowRight") {
      dispatch({ type: START_LOADING });
      dispatch({ type: INCREMENT_SLIDE });
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', closeByEsc);
    return (() => document.removeEventListener('keydown', closeByEsc));
    // eslint-disable-next-line
  }, []);

  return createPortal((
    <ModalOverlay handleCloseModal={handleClose}>
      <div
        className={`${styles.container} ${!backing && styles.container__withoutBacking} ${backingWhite && styles.container__white}`}
        id="modal-container"
      >
        <button
          className={`${backingWhite ? styles.button__black : styles.button}`}
          onClick={handleClose}
        >
        </button>
        {children}
      </div>
    </ModalOverlay>
  ), portalDiv
  );
}

export default Modal;
